module.exports = __webpack_public_path__ + "static/media/qr-code.308ec35e.svg";